// Only untouched, initial drafts are eligible for automatic local preparation.
export const isFreshDraft = plan => plan?.revision === 1 && !plan.approved_at &&
  !plan.draft.tests.some(t => t.ads?.length);

export function preparedDraft(proposal, suggestions = [], catalog) {
  const eligible = new Set((catalog?.ads || []).filter(a => !a.blocked).map(a => a.resource));
  return {...proposal, tests: proposal.tests.map(t => ({...t, ads: t.selected && !t.ads.length
    ? [...new Set(suggestions.filter(s => s.testId === t.id && eligible.has(s.adResource)).map(s => s.adResource))].slice(0, 10)
    : t.ads}) )};
}
